import { css } from "lit";

export const holloProfileImageStyles = css`
  .hollo-avatar {
    display: block;
    border-radius: 50%;
    object-fit: cover;
  }
  .hollo-click-circle {
    z-index: 10000;
  }
  .hollo-placeholder {
    border-radius: 50%;
    background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
  }
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
